import React, { useState } from "react";
import "./style/EditFile.scss";
import CustomDatePicker from "../../../components/CustomDatePicker/CustomDatepicker";
import BoxFooter from "../../../components/BoxFooter/BoxFooter";
import Button from "../../../components/Button/Button";

const EditFile = (props) => {
  const { file, sendFileEdit } = props;

  const getValidDate = (value) => {
    if (!value) return null;

    const parsedDate = value instanceof Date ? value : new Date(value);
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
  };

  const initialReceivedAt =
    file.receivedAt || file.deliveryControl?.completionDates?.received || null;

  const initialState = {
    version: file.version,
    chapterNumber: file.chapterNumber,
    blockNumber: file.blockNumber,
    receivedAt: initialReceivedAt,
  };

  const [state, setstate] = useState(initialState);

  const getDate = (date) => {
    if (!(date instanceof Date) || Number.isNaN(date.getTime())) {
      setstate({
        ...state,
        receivedAt: null,
      });
      return;
    }

    let d = new Date(
      date.getTime() - date.getTimezoneOffset() * 60000
    ).toISOString();
    setstate({
      ...state,
      receivedAt: d,
    });
  };

  const sendEditFiles = (e) => {
    e.preventDefault();

    const attachmentTypeId = file.type?.id ?? file.attachmentTypeId ?? 0;

    let obj = {
      id: file.id,
      version: state.version,
      receivedAt: state.receivedAt,
      attachmentTypeId,
    };

    sendFileEdit(obj);
  };

  return (
    <div className="EditFileContainer">
      <form onSubmit={(e) => sendEditFiles(e)}>
        <div className="fileInfo">
          <CustomDatePicker
            label="Recebido Em"
            name="attachmentReceivedAt"
            darkBackgroundColor={false}
            handleChangeDate={getDate}
            date={getValidDate(state.receivedAt)}
          />
        </div>

        <BoxFooter>
          <Button
            text="Salvar"
            classButton="buttonGreen large"
            typeButton="submit"
            dataQA="button-prospect-new-save"
          />
        </BoxFooter>
      </form>
    </div>
  );
};

export default EditFile;
